export const CATEGORY_ITEMS = [
  {
    label: "सामान्य",
    slug: "general",
    category: "General",
    aliases: ["general", "सामान्य"],
  },
  {
    label: "राजनीति",
    slug: "politics",
    category: "राजनीति",
    aliases: ["politics", "राजनीति"],
  },
  {
    label: "खेल",
    slug: "sports",
    category: "खेल",
    aliases: ["sports", "sport", "khel", "खेल"],
  },
  {
    label: "देश",
    slug: "desh",
    category: "देश",
    aliases: ["देश", "national"],
  },
  {
    label: "विदेश",
    slug: "videsh",
    category: "विदेश",
    aliases: ["विदेश", "international", "world"],
  },
  {
    label: "स्वास्थ्य",
    slug: "health",
    category: "स्वास्थ्य",
    aliases: ["health", "healthcare", "स्वास्थ्य"],
  },
  {
    label: "धर्म",
    slug: "dharm",
    category: "धर्म",
    aliases: ["धर्म", "religion"],
  },
  {
    label: "सिनेमा",
    slug: "cinema",
    category: "सिनेमा",
    aliases: ["सिनेमा", "cinema", "entertainment"],
  },
  {
    label: "विज्ञान और प्रौद्योगिकी",
    slug: "science-technology",
    category: "विज्ञान और प्रौद्योगिकी",
    aliases: [
      "science",
      "technology",
      "science and technology",
      "sci-tech",
      "विज्ञान",
      "प्रौद्योगिकी",
      "विज्ञान और प्रौद्योगिकी",
    ],
  },
];
